function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4V9H9V3H4C3.44772 3 3 3.44772 3 4ZM11 3V9H21V4C21 3.44772 20.5523 3 20 3H11ZM3 11H9V21H4C3.44772 21 3 20.5523 3 20V11ZM11 21V11H21V20C21 20.5523 20.5523 21 20 21H11ZM14.5 14C15.3284 14 16 14.6996 16 15.5626C16 14.6996 16.6716 14 17.5 14C18.3284 14 19 14.6996 19 15.5625C19 16.0741 18.764 16.5283 18.3991 16.8133L16.0001 18.9999V19L16 19L16 19V18.9999L13.6016 16.8138C13.2363 16.5288 13 16.0744 13 15.5625C13 14.6996 13.6716 14 14.5 14Z"
});

var SvgRegistryInactive = function SvgRegistryInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistryInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Registry-Inactive.d24c73ea.svg";
export { ForwardRef as ReactComponent };